export {
  actions as assessmentPageActions,
  reducer as assessmentPageReducer,
  reduxNamespaceKey,
} from './actionReducers'
